import styled from 'styled-components';

export const CancelButton = styled.button`
  ${props => props.theme.typography.body}
  color: ${props => props.theme.colors.hero.cranberry};
  border: none;
  background-color: ${props => props.theme.colors.background.lightest};

  &:hover {
    text-decoration: underline;
  }
`;
